import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './par-type-kafalat.reducer'; // Assurez-vous que le chemin est correct
import { IParTypeKafalat } from 'app/shared/model/par-type-kafalat.model'; // Assurez-vous que le chemin est correct
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/status.model'; // Assurez-vous que le chemin est correct

export const ParTypeKafalatUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const parTypeKafalatEntity = useAppSelector(state => state.parTypeKafalat.entity);
  const loading = useAppSelector(state => state.parTypeKafalat.loading);
  const updating = useAppSelector(state => state.parTypeKafalat.updating);
  const updateSuccess = useAppSelector(state => state.parTypeKafalat.updateSuccess);
  const statusValues = Object.keys(Status);

  const handleClose = () => {
    props.history.push('/par-type-kafalat');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, [dispatch, props.match.params.id, isNew]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess, handleClose]);

  const saveEntity = values => {
    const entity = {
      ...parTypeKafalatEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? { status: 'ACTIVE' } // Valeur par défaut pour un nouvel enregistrement
      : {
          status: parTypeKafalatEntity.status,
          ...parTypeKafalatEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="almobadaraMasterDataApp.parTypeKafalat.home.createOrEditLabel" data-cy="ParTypeKafalatCreateUpdateHeading">
            <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.home.createOrEditLabel">
              Create or edit a ParTypeKafalat
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="par-type-kafalat-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypeKafalat.name')}
                id="par-type-kafalat-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypeKafalat.nameAr')}
                id="par-type-kafalat-nameAr"
                name="nameAr"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypeKafalat.nameEn')}
                id="par-type-kafalat-nameEn"
                name="nameEn"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypeKafalat.status')}
                id="par-type-kafalat-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {statusValues.map(status => (
                  <option value={status} key={status}>
                    {translate('almobadaraMasterDataApp.Status.' + status)}
                  </option>
                ))}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/par-type-kafalat" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParTypeKafalatUpdate;
